import videojs from 'video.js';
import { objectFitter } from '../utils/Utils';
import { CircleButtonAnimation } from '../utils/CircleButtonAnimation';

export const VideoController = () => {

  $('[data-open="video"]').click((e) => {

    if(window.circleAnimComplete) {
      const $this = $(e.currentTarget);
      const id = $this.attr('data-id');
      const video = $this.attr('data-video');
      const poster = $this.attr('data-poster');
      let player = '';
      initVideoJs(player, id, poster, video);
    }
  });

  objectFitter('.video-bg-wrapper', 'video');
}


const createMarkup = (poster, file, id) => {
  let closeIcon = '<svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><polygon transform="translate(7.144003, 7.144003) rotate(45.000000) translate(-7.144003, -7.144003) " points="-0.759997129 6.07200287 6.08800287 6.07200287 6.08800287 -0.711997129 8.26400287 -0.711997129 8.26400287 6.07200287 15.0480029 6.07200287 15.0480029 8.21600287 8.26400287 8.21600287 8.26400287 15.0000029 6.08800287 15.0000029 6.08800287 8.21600287 -0.759997129 8.21600287"></polygon></svg>';
  closeIcon += '<svg width="54px" height="54px" viewBox="0 0 54 54" class="circle-anim"><circle class="circle" cx="27" cy="27" r="25" stroke-dasharray="160" stroke-dashoffset="160"/></svg>';

  let videoMarkup = '';
      videoMarkup += '<div class="video-wrapper" data-id="' + id + '">';
      videoMarkup += '<div class="video-container" style="opacity: 0;">';
      videoMarkup += '<button class="video-close" data-id="' + id + '" data-close="video"><i class="icn-circle icn-circle--lrg">' + closeIcon + '</i></button>';
      videoMarkup += '<video id="' + id + '" class="video-js" controls muted preload="auto" poster="' + poster + '">';
      videoMarkup += '<source src="' + file + '" type="video/mp4"></source>';
      videoMarkup += '</video>';
      videoMarkup += '</div>';
      videoMarkup += '<div class="video-overlay" data-id="' + id + '" data-close="video" style="opacity: 0;"></div>';
      videoMarkup += '</div>';

  $('body').prepend(videoMarkup);
}


const initVideoJs = (player, id, poster, video) => {
  window.allowScroll = false;

  createMarkup(poster, video, id);

  let options = {
    fluid: true,
    inactivityTimeout: 1000
  };

  player = videojs(id, options);

  player.ready(function() {
    $('.video-overlay').css({opacity: '1'});
    $('.video-container').css({opacity: '1'});
    this.play();

    this.on('useractive', () => {
      $('.video-container').removeClass('user-inactive').addClass('user-active');
    });

    this.on('userinactive', () => {
      $('.video-container').removeClass('user-active').addClass('user-inactive');
    });

    this.on('playing', () => {
      $('.video-container').addClass('playing');
    });

    this.on(['waiting', 'pause'], () => {
      $('.video-container').removeClass('playing');
    });
  })

  CircleButtonAnimation($('.video-close'));

  // $('.video-close').on({
  //   mouseenter: (e) => {
  //     player.options().inactivityTimeout = 0;
  //   },

  //   mouseleave: (e) => {
  //     player.options().inactivityTimeout = 1000;
  //   },
  // })

  $('[data-close="video"]').on('click', (e) => {
    const $this = $(e.currentTarget);
    const id = $this.attr('data-id');

    if(window.circleAnimComplete || $(e.currentTarget).hasClass('video-overlay')) {
      destroyPlayer(player, id);
    }

  })
}


const destroyPlayer = (player, id) => {
  player.pause();

  $('.video-overlay').css({opacity: '0'});
  $('.video-container').css({opacity: '0'});

  setTimeout(() => {
    $('.video-wrapper[data-id="' + id +'"]').remove();
    $('.video-overlay[data-id="' + id +'"]').remove();

    player.dispose();
    window.allowScroll = true;
  }, 500);

}



// WEBPACK FOOTER //
// ./src/js/controllers/VideoController.js